/**
 * Get Procore API base URL
 *
 * Returns the base URL for Procore API requests.
 * - Local dev with token: Uses /procore-api (Vite proxy)
 * - Production/embedded: Uses empty string (relative paths on same domain)
 * - Can be overridden via REACT_APP_PROCORE_API_BASE_URL env var
 */
export function getProcoreApiBaseUrl(): string {
    // If explicitly set, use that value
    if (import.meta.env.REACT_APP_PROCORE_API_BASE_URL) {
        return import.meta.env.REACT_APP_PROCORE_API_BASE_URL;
    }

    // If using OAuth token (local dev), use proxy path
    const accessToken = import.meta.env.REACT_APP_PROCORE_ACCESS_TOKEN;
    if (accessToken) {
        return "/procore-api";
    }

    // In production (cookie auth), use empty string for relative paths
    // The app is embedded in Procore, so APIs are on the same domain
    return "";
}
